/* eslint-disable jsx-a11y/role-supports-aria-props */
import $ from 'jquery';
import { ReactNode, useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import Sidebar from '../components/Sidebar';
import Select from "./Select";

export type PanelItem = {
    id: string,
    key?: string,
    name: string,
    element: ReactNode,
}

type Props = {
    id: string,
    title?: string,
    activeKey?: string,
    panels: PanelItem[],
    navbar?: boolean,
    fill?: boolean,
    justify?: boolean,
    variant?: 'tabs' | 'pills' | 'underline',
    showSidebar?: boolean,
    onChange?: (index: number) => Promise<void>,
    selectTitle?: string,
    emptyTabText?: string,
    emptyContentText?: string,
}

export default function CustomTab(props: Props) {
    const {
        id, title, activeKey, panels, navbar, fill, justify, variant = 'tabs',
        showSidebar, onChange, selectTitle, emptyTabText, emptyContentText
    } = props;
    const defaultActiveKey = activeKey ? activeKey : (panels && panels.length ? panels[0].id : undefined);
    const [panelIndex, setPanelIndex] = useState<number>(panels && panels.length ? panels.findIndex(panel => panel.id === defaultActiveKey) : 0);
    const panelOptions = panels && panels.length ? panels.map((panel: PanelItem, index: number) => {
        return {
            label: panel.name,
            value: index
        }
    }) : [];

    useEffect(() => {
        const newIndex = panels.findIndex(panel => panel.id === activeKey);
        if (newIndex !== -1) {
            setPanelIndex(newIndex);
        } else {
            setPanelIndex(0);
        }
    }, [activeKey, panels]);

    return <>
        <div id={id} className="tab-element">
            {title ? <div id={`${id}_title`} className="tab-title">{title}</div> : <></>}
            {panels.length ? <Tab.Container mountOnEnter defaultActiveKey={defaultActiveKey} activeKey={activeKey}>
                <Nav id={`${id}_navbar`} navbar={navbar} fill={fill} justify={justify} variant={variant}>
                    {panels.map((panel: PanelItem, index: number) => {
                        return <Nav.Item
                            id={`${id}_${panel.id}_nav_item`}
                            key={index}
                            className="tab-nav-item-desktop"
                        >
                            <Nav.Link
                                id={`${id}_${panel.id}_nav_link`}
                                eventKey={panel.key ? panel.key : panel.id}
                                onClick={async (event) => {
                                    setPanelIndex(index);
                                    onChange && await onChange(index);
                                }}
                                data-tab-index={index}
                            >
                                {panel.name}
                            </Nav.Link>
                        </Nav.Item>
                    })}
                    <div className='tab-nav-item-mobile'>
                        <span className='fw-bold ms-3 me-2'>{selectTitle}</span>
                        <Select
                            id={`${id}-tab-mobile-select`}
                            name={`${id}-tab-mobile-select`}
                            className='w-50'
                            defaultValue={panelOptions[panelIndex] ? panelOptions[panelIndex] : undefined}
                            value={panelOptions[panelIndex] ? panelOptions[panelIndex] : undefined}
                            options={panelOptions}
                            onChange={async (option) => {
                                (async () => {
                                    $(`#${id} .tab-nav-item-desktop .nav-link.active`).removeClass('active');
                                })().then(async () => {
                                    setPanelIndex(option.value);
                                    onChange && await onChange(option.value);
                                    $(`#${id} .tab-nav-item-desktop *[data-tab-index=${option.value}]`).addClass('active');
                                });
                            }}

                        />
                    </div>

                </Nav>
                <Tab.Content id={`${id}-tab-mobile`} className="tab-content-mobile">
                    {showSidebar ? <Row id="page_content">
                        <Col id="content" xs={12} lg={9}>
                            <div>
                                {panels[panelIndex] ? panels[panelIndex].element : <>
                                    {emptyContentText ? emptyContentText : 'Nessun contenuto da mostrare in questa tab'}
                                </>}
                            </div>
                        </Col>
                        <Col id="sidebar" xs={12} lg={3} className="pt-3">
                            <Sidebar />
                        </Col>
                    </Row> : <div>
                        {panels[panelIndex] ? panels[panelIndex].element : <>
                            {emptyContentText ? emptyContentText : 'Nessun contenuto da mostrare in questa tab'}
                        </>}
                    </div>}
                </Tab.Content>
            </Tab.Container> : <>
                {emptyTabText ? emptyTabText : 'Nessuna tab da mostrare in questa sezione'}
            </>}
        </div>
    </>
}
